import { mockRegistrationApplianceDetails } from './registration-appliance-details.mock';

const { basketItemId, ...registrationApplianceDetailsCLP } =
  mockRegistrationApplianceDetails;

registrationApplianceDetailsCLP.id = '';

export const mockRegistrationApplianceDetailsCLP =
  registrationApplianceDetailsCLP;
